import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CollectionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"collections"}/>
}
